
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/privateAppsPanel/components/newBlockButton/newBlockButton.scss.css.virtualfile';
        module.exports = {"new-block-button-container":"_new-block-button-container_maqeu_1","newBlockButtonContainer":"_new-block-button-container_maqeu_1"};